import { searchSuggestionDisplay } from 'store/homePage/homePageActions';
import { getSearchLocalStorage } from '../../../components/HomePage/localStorage';
import { createSearchSuggestionDisplayEvent } from '../eventCreators';
import { createSearchSuggestionDisplayEventPayload } from '../dataHelpers/createSearchSuggestionDisplayEventPayload';

const getComponentVariant = (componentVariants, count) => {
  const propertySearches = componentVariants.filter(Boolean).length;
  const destinationSearches = count - propertySearches;
  if (destinationSearches > 0) {
    if (propertySearches > 0) {
      return 'destinations and properties';
    } else {
      return 'destinations';
    }
  } else {
    return 'properties';
  }
};

const emitSearchSuggestionDisplayEvent = () => {
  const recentSearches = getSearchLocalStorage();
  const count = recentSearches.length;
  const searchRecent = recentSearches.map((search) => search.location);
  const componentVariants = recentSearches.map((search) => search.isPropertySearch);
  const componentVariant = getComponentVariant(componentVariants, count);

  return createSearchSuggestionDisplayEvent(
    createSearchSuggestionDisplayEventPayload({
      count,
      searchRecent,
      viewMode: 'list',
      componentVariant,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [searchSuggestionDisplay]: emitSearchSuggestionDisplayEvent };
